<template>
  <div>
    <el-form ref="searchForm" :model="searchForm" inline>
      <el-form-item label="申请发货单:" prop="deliveryNum">
        <el-input v-model.trim="searchForm.deliveryNum" placeholder="请输入申请发货单号" clearable />
      </el-form-item>
      <el-form-item label="客户名称:" prop="agentName">
        <el-input v-model.trim="searchForm.agentName" placeholder="请输入客户名称" clearable />
      </el-form-item>
      <el-form-item label="部门名称:" prop="department">
        <el-input v-model.trim="searchForm.department" placeholder="请输入部门名称" clearable />
      </el-form-item>
      <el-form-item label="销往国家/区域:" prop="overSeasSalesCountry">
        <el-input v-model.trim="searchForm.overSeasSalesCountry" placeholder="请输入销往国家/区域" clearable />
      </el-form-item>
      <el-form-item label="现销/赊销:" prop="salesType">
        <el-select v-model="searchForm.salesType" clearable>
          <el-option label="全部" value="" />
          <el-option v-for="item in internationalSalesType" :key="item.code" :value="item.code" :label="item.name" />
        </el-select>
      </el-form-item>
      <el-form-item label="是否自动化:" prop="automaticOrder">
        <el-select
          v-model="searchForm.automaticOrder"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="option in isOrderAutoList"
            :key="option.name"
            :label="option.name"
            :value="option.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="申请时间:" prop="endTime">
        <el-date-picker
          v-model="searchForm.startTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          @change="handleStartTimeChange"
        />
        <div style="display: inline-block;width: 10px;text-align: center">
          -
        </div>
        <el-date-picker
          v-model="searchForm.endTime"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
          :picker-options="pickerOptions"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">
          搜索
        </el-button>
        <el-button type="default" @click="handleReset">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <div class="operate-btn-wrap">
      <el-button type="primary" :loading="isUploadFileLoading" @click="exportShipmentReport()">
        导出发货单报表
      </el-button>
    </div>
    <el-table v-loading="isTableLoading" :data="tableData" border>
      <el-table-column align="left" label="办理" width="50">
        <template v-slot="{row}">
          <el-button type="text" @click="approveOrLookDetail(row,'approve')">
            办理
          </el-button>
        </template>
      </el-table-column>
      <el-table-column align="left" label="申请发货单" prop="deliveryNum" width="140">
        <template v-slot="{row}">
          <el-button type="text" @click="approveOrLookDetail(row,'detail')">
            {{ row.deliveryNum }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column align="left" label="部门名称" prop="department" />
      <el-table-column align="left" label="客户名称" prop="agentName" /><!--取订货单位-->
      <el-table-column align="left" label="申请人" prop="createByName" /><!--取商务姓名-->
      <el-table-column align="left" label="销往国家/区域" prop="overSeasSalesCountry" />
      <el-table-column align="left" label="现销/赊销" prop="salesType" />
      <el-table-column align="right" label="申请发货金额" prop="amountSum" header-align="left">
        <template v-slot="{row}">
          {{ (row.amountSum ? Number(row.amountSum) : 0).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column align="left" label="币种" prop="currencyName" />
      <el-table-column
        prop="physicalFlag"
        label="是否含非实物"
        align="left"
        width="80"
      >
        <template v-slot="{row}">
          {{ row.physicalFlag ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="batteryFlag"
        label="是否带电池"
        align="left"
        width="80"
      >
        <template v-slot="{row}">
          {{ row.batteryFlag ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column align="left" label="已分配金额" prop="assignAll">
        <template v-slot="{row}">
          <el-button v-if=" row.assignAll === '查看'" type="primary" style="background:none; border: none; color: cornflowerblue;" @click="insertTheAmountAllocated(row)">
            查看
          </el-button>
          <span v-else type="text" style="font-weight: 500; font-size: 18px;">
            --
          </span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="申请时间" prop="submitTime" width="150" />
      <el-table-column align="left" label="是否自动化" prop="automaticOrder">
        <template v-slot="{row}">
          {{ row.orderAutoPassingStatus ===true ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column align="left" label="自动化状态" prop="automaticStatus">
        <template v-slot="{row}">
          <div class="item-value">
            <span v-if="row.orderAutoPassingSuccess === 0">
              <el-button type="text" @click="passingStatus(row.reason,'未过单原因')">未过单</el-button>
            </span>
            <span v-if="row.orderAutoPassingSuccess === 1 ">成功</span>
            <span v-if="row.orderAutoPassingSuccess === 2 ">
              <el-button type="text" @click="passingStatus(row.reason,'失败原因')">失败</el-button>
            </span>
            <!-- 非自动过单 && 自动化状态 -->
            <span v-if="!row.orderAutoPassingStatus && !row.orderAutoPassingSuccess">
              ——
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 30, 40]"
      :page-size.sync="pageState.pageSize"
      :current-page.sync="pageState.pageIndex"
      layout="->,total, prev, pager, next, jumper,sizes"
      :total="pageState.total"
      style="margin-top: 10px"
      hide-on-single-page
      @size-change="handlerSizeChange"
      @current-change="handlerCurrentChange"
    />
    <!-- 查看 分配金额 -->
    <el-dialog
      :visible.sync="isShowinsertTheAmountAllocatedDialog"
      width="70%"
    >
      <template #title>
        查看分配(<span style="color:#FF0000;">{{ title }}</span>)
      </template>
      <el-table :data="allocatedDetail" border>
        <el-table-column label="序号" type="index" align="left" width="50" />
        <el-table-column label="合同号" prop="contractNum" align="left" />
        <el-table-column label="实际结算金额" prop="actualSettlementAmount" align="right" header-align="left">
          <template v-slot="{row}">
            {{ Number(row.actualSettlementAmount).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column label="已分配金额" prop="assignAll" align="right" header-align="left">
          <template v-slot="{row}">
            {{ Number(row.assignAll).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column label="预付款金额" prop="advancePaymentAmount" align="right" header-align="left">
          <template v-slot="{row}">
            {{ Number(row.advancePaymentAmount).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column label="预付款比例" prop="prepaymentRatioNum" align="right" header-align="left">
          <template v-slot="{row}">
            {{ (Number(row.prepaymentRatioNum) * 100).toFixed(2) }}%
          </template>
        </el-table-column>
        <el-table-column label="已发货金额" prop="shippedAmount" align="right" header-align="left">
          <template v-slot="{row}">
            {{ Number(row.shippedAmount).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column label="流程中单据金额" prop="processAmount" align="right" header-align="left">
          <template v-slot="{row}">
            {{ Number(row.processAmount).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column label="本次发货金额" prop="nowShipmentAmount" align="right" header-align="left">
          <template v-slot="{row}">
            {{ Number(row.nowShipmentAmount).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column label="验证金额差异" prop="amountDifference" align="right" header-align="left">
          <template v-slot="{row}">
            <span :style="Number(row.amountDifference)<0 && {color:'red'}">{{ Number(row.amountDifference).toFixed(2) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin: 10px;">
        说明：验证金额差异公式=（已分配金额-预付款金额）-（已发货金额+流程中单据金额+本次发货金额）*（1-预付款比例）
      </div>
      <div class="footer-btn">
        <el-button type="default" @click="close">
          关闭
        </el-button>
      </div>
    </el-dialog>
    <InternationalApplyForDeliveryDialog
      :dialog-visible-from-apply-for-delivery="dialogVisibleFromApplyForDelivery"
      :current-click-data="currentClickData"
      :is-approve="isApprove"
      :is-detail="isDetail"
      :show-notes="3"
      :approve-role="'orderTaker'"
      @on-status-dialog="updateDialogVisibleFromApplyForDelivery"
      @refresh-table="handleReset"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getInvoiceToBeReviewed, orderClerkAllocated, getExportPartialInvoice } from '@/API/international';
import InternationalApplyForDeliveryDialog from '@/views/business/components/InternationalApplyForDeliveryDialog.vue';
import { downloadBlobFile } from '@/libs/util.js';
import { Notification } from 'element-ui';

/**
 * 待审核发货单
 */
export default {
  name: 'InternationalDeliveryOrderToBeReviewed',
  components: { InternationalApplyForDeliveryDialog },
  data () {
    return {
      isUploadFileLoading: false, // 导出发货单报表Loading
      title: '',
      isShowinsertTheAmountAllocatedDialog: false,
      allocatedDetail: [],
      searchForm: {
        deliveryNum: '',
        agentName: '',
        department: '',
        overSeasSalesCountry: '',
        automaticOrder: null, // 是否自动化
        salesType: '',
        startTime: '',
        endTime: ''
      },
      pageState: {
        pageIndex: 1,
        pageSize: 10,
        total: 10
      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.startTime) {
            let date = new Date(this.searchForm.startTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      },
      isTableLoading: false,
      tableData: [],
      currentClickData: {},
      isApprove: false,
      isDetail: true,
      dialogVisibleFromApplyForDelivery: false
    };
  },
  computed: {
    ...mapState('enumeration', ['internationalSalesType', 'isOrderAutoList']),
    ...mapState('pagesTemporary', ['OrderPersionContractListTabActive'])
  },
  /**
   * 审批与详情应该相反
   */
  watch: {
    isApprove (value) {
      this.isDetail = !value;
    },
    isDetail (value) {
      this.isApprove = !value;
    },
    OrderPersionContractListTabActive () {
      this.OrderPersionContractListTabActive === '8' && this.handleReset();
    }
  },
  methods: {
    // 查看 已分配金额
    insertTheAmountAllocated (row) {
      this.title = row.deliveryNum;
      orderClerkAllocated(row.id).then(res => {
        let json = res.data;
        if (json.status) {
          this.isShowinsertTheAmountAllocatedDialog = true;
          this.allocatedDetail = json.data;
        }
      }).catch(() => {
        this.isShowinsertTheAmountAllocatedDialog = false;
      });
    },
    close () {
      this.isShowinsertTheAmountAllocatedDialog = false;
    },
    // 导出发货清单
    exportShipmentReport () {
      this.isUploadFileLoading = true;
      let params = {
        pageIndex: this.pageState.pageIndex,
        pageSize: this.pageState.pageSize
      };
      for (let key in this.searchForm) {
        this.searchForm[key] && (params[key] = this.searchForm[key]);
      }
      let haveStartTime = !!this.searchForm.startTime;
      let haveEndTime = !!this.searchForm.endTime;
      let timeParams = {};
      if (haveStartTime && haveEndTime) {
        timeParams = {
          startTime: `${this.searchForm.startTime} 00:00:00`,
          endTime: `${this.searchForm.endTime} 23:59:59`
        };
      } else if (haveStartTime || haveEndTime) {
        if (haveStartTime) {
          timeParams = {
            startTime: `${this.searchForm.startTime} 00:00:00`
          };
        } else {
          timeParams = {
            endTime: `${this.searchForm.endTime} 23:59:59`
          };
        }
      }
      getExportPartialInvoice({ ...params, ...timeParams }).then((res) => {
        if (res.data instanceof Blob) {
          downloadBlobFile({
            content: res.data,
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            fileName: '发货单报表'
          });
          Notification.success('导出发货单报表成功!');
          this.isUploadFileLoading = false;
        }
        console.log('啊~~~~~~~~~~~~我要导出发货单报表了哦!!!!!!', res);
      }).catch(() => {
        this.isUploadFileLoading = false;
      });
    },
    /**
     * 搜索时应当将分页器下标改为1
     */
    handleSearch () {
      this.pageState.pageIndex = 1;
      this.getData();
    },
    getData () {
      this.isTableLoading = true;
      let params = {
        pageIndex: this.pageState.pageIndex,
        pageSize: this.pageState.pageSize
      };
      for (let key in this.searchForm) {
        this.searchForm[key] && (params[key] = this.searchForm[key]);
      }
      console.log(params, this.searchForm);
      let haveStartTime = !!this.searchForm.startTime;
      let haveEndTime = !!this.searchForm.endTime;
      let timeParams = {};
      if (haveStartTime && haveEndTime) {
        timeParams = {
          startTime: `${this.searchForm.startTime} 00:00:00`,
          endTime: `${this.searchForm.endTime} 23:59:59`
        };
      } else if (haveStartTime || haveEndTime) {
        if (haveStartTime) {
          timeParams = {
            startTime: `${this.searchForm.startTime} 00:00:00`
          };
        } else {
          timeParams = {
            endTime: `${this.searchForm.endTime} 23:59:59`
          };
        }
      }

      getInvoiceToBeReviewed({ ...params, ...timeParams }).then(res => {
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.pageState.total = json.data.total;
        }
        this.isTableLoading = false;
      }).catch(e => {
        this.isTableLoading = false;
      });
    },
    handleReset () {
      this.$refs.searchForm.resetFields();
      this.searchForm.startTime = '';
      this.searchForm.automaticOrder = null;
      this.pageState.pageIndex = 1;
      this.pageState.pageSize = 10;
      this.getData();
    },
    handlerSizeChange (value) {
      this.pageState.pageIndex = 1;
      this.pageState.pageSize = value;
      this.getData();
    },
    handlerCurrentChange (value) {
      this.pageState.pageIndex = value;
      this.getData();
    },
    passingStatus (row, title) {
      console.log(row);
      this.$alert(row, title, {
        confirmButtonText: '确定'
      });
    },
    handleStartTimeChange (value) {
      let startTime = new Date(value);
      let endTime = new Date(this.searchForm.endTime);
      if (startTime.getTime() > endTime.getTime()) {
        this.searchForm.endTime = undefined;
      }
    },
    /**
     * 申请发货单审批或者详情
     */
    approveOrLookDetail (row, type) {
      type === 'approve' && (this.isApprove = true);
      type === 'detail' && (this.isDetail = true);
      this.currentClickData = row;
      this.dialogVisibleFromApplyForDelivery = true;
    },
    updateDialogVisibleFromApplyForDelivery (value) {
      this.dialogVisibleFromApplyForDelivery = value;
    }
  },
  mounted () {
    this.handleSearch();
  }
};
</script>

<style scoped>
.footer-btn{
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
